import { render, staticRenderFns } from "./FeaturedPostToday.vue?vue&type=template&id=2611796d&scoped=true&"
import script from "./FeaturedPostToday.vue?vue&type=script&lang=js&"
export * from "./FeaturedPostToday.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPostToday.vue?vue&type=style&index=0&id=2611796d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611796d",
  null
  
)

export default component.exports